<template>
  <v-expansion-panels>
    <v-expansion-panel>
      <v-expansion-panel-header>
        <!-- <template> -->
        <template v-slot:default="{ open }">
          <v-row no-gutters v-if="cargo">
            <v-col cols="12" xs="12" sm="12" md="12" lg="12">
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="1" lg="1" class="body-2">{{
                  formatDate(cargo.tentativeDate)
                }}</v-col>
                <v-col cols="12" xs="12" sm="12" md="1" lg="1" class="body-2">{{
                  cargo.clientName
                }}</v-col>
                <v-col cols="12" xs="12" sm="12" md="1" lg="1" class="body-2">{{
                  cargo.partLoad ? "Part " : "Full "
                }}</v-col>
                <v-col cols="12" xs="12" sm="12" md="1" lg="1" class="body-2">{{
                  cargo.material
                }}</v-col>
                <v-col cols="12" xs="12" sm="12" md="1" lg="1" class="body-2">{{
                  cargo.truckType
                }}</v-col>
                <v-col cols="12" xs="12" sm="12" md="1" lg="1" class="body-2">{{
                  cargo.weight
                }}</v-col>
                <v-col cols="12" xs="12" sm="12" md="2" lg="2" class="body-2">{{
                  cargo.src
                    ? cargo.src.city +
                      (cargo.src.state ? ", " + cargo.src.state : "")
                    : ""
                }}</v-col>
                <v-col cols="12" xs="12" sm="12" md="2" lg="2" class="body-2">{{
                  cargo.dst
                    ? cargo.dst.city +
                      (cargo.dst.state ? ", " + cargo.dst.state : "")
                    : ""
                }}</v-col>

                <v-col
                  cols="12"
                  xs="12"
                  sm="12"
                  md="2"
                  lg="2"
                  class="text-center pl-0"
                >
                  <z-confirm-button
                    v-if="open"
                    class="float-right"
                    color="red lighten-1"
                    small
                    fab
                    text
                    dark
                    :message="$i18n.t('Do you want to delete this cargo ?')"
                    @click="deleteCargo(cargo)"
                  >
                    <v-icon>mdi-trash-can-outline</v-icon>
                  </z-confirm-button>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        class="float-right"
                        color="primary"
                        small
                        fab
                        text
                        dark
                        :to="'/cargo/' + cargo._id"
                        v-on="on"
                        @click.native.stop
                      >
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $i18n.t("Edit") }}</span>
                  </v-tooltip>
                  <!-- <v-tooltip top v-if="cargo.showBids && open">
                    <template v-slot:activator="{ on }">
                      <v-btn
                        class="float-right"
                        color="primary"
                        small
                        fab
                        text
                        dark
                        v-on="on"
                        @click="showBids(cargo)"
                      >
                        <v-icon>mdi-chat</v-icon>
                      </v-btn>
                    </template>
                    <span>{{$i18n.t('Bids')}}</span>
                  </v-tooltip>-->
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </template>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-row no-gutters v-if="cargo">
          <v-col cols="12" md="3">
            <v-row>
              <v-col cols="12" md="3">{{ $i18n.t("Origin") }}:</v-col>
              <v-col cols="12" md="9">{{
                cargo.src ? cargo.src.addressLine : ""
              }}</v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="3">{{ $i18n.t("Destination") }}:</v-col>
              <v-col cols="12" md="9">{{
                cargo.dst ? cargo.dst.addressLine : ""
              }}</v-col>
            </v-row>
          </v-col>
          <v-col
            cols="12"
            md="3"
            v-if="cargo.quotRequest && cargo.quotRequest.wishPrice"
          >
            <v-row>
              <v-col cols="12" md="4">{{ $i18n.t("Wish Price") }}:</v-col>
              <v-col cols="12" md="8">{{ cargo.quotRequest.wishPrice }}</v-col>
            </v-row>
          </v-col>
          <v-col
            cols="12"
            md="3"
            v-if="cargo.quotRequest && cargo.quotRequest.bidsRange"
          >
            <v-row>
              <v-col cols="12" md="4">{{ $i18n.t("Bids") }}:</v-col>
              <v-col cols="12" md="8">{{ cargo.bidsRange }}</v-col>
            </v-row>
          </v-col>

          <v-col cols="12" md="4" v-if="cargo.bid">
            <v-list-item-content calss="px-3">
              <v-row>
                <v-col cols="12" md="4" class="mx-3">
                  <h3>{{ $i18n.t("My Bid") }}</h3>
                </v-col>
              </v-row>
            </v-list-item-content>
            <v-simple-table dense style="padding: 10px">
              <thead>
                <tr>
                  <th class="primary--text">{{ $i18n.t("Bid Price") }}</th>
                  <th class="primary--text">{{ $i18n.t("Status") }}</th>
                  <!-- <th class="text-right primary--text">{{ $i18n.t("Action") }}</th> -->
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <span>{{
                      cargo.bid.fare ? cargo.bid.fare.total : ""
                    }}</span>
                  </td>
                  <td>
                    <span>{{ cargo.bid.statusStr }}</span>
                  </td>
                  <!-- <td>
                    <z-confirm-button
                      class="float-right"
                      color="success"
                      small
                      fab
                      text
                      dark
                      :message="$i18n.t('Do you want to reject this bid ?')"
                      @click="rejectBid(cargo.bid)"
                    >
                      <v-icon>mdi-check</v-icon>
                    </z-confirm-button>
                  </td>-->
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>

          <v-col cols="12" md="4" v-if="cargo.showBids">
            <v-list-item-content calss="px-3">
              <v-row>
                <v-col cols="12" md="4" class="mx-3">
                  <h3>{{ $i18n.t("Bids") }}</h3>
                </v-col>
              </v-row>
            </v-list-item-content>
            <v-simple-table dense style="padding: 10px">
              <thead>
                <tr>
                  <th class="primary--text">{{ $i18n.t("Supplier") }}</th>
                  <th class="primary--text">{{ $i18n.t("Bid Price") }}</th>
                  <th class="primary--text">{{ $i18n.t("Status") }}</th>
                  <th class="text-right primary--text">
                    {{ $i18n.t("Action") }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(bid, index) in cargo.bids" :key="'bid' + index">
                  <td>
                    <span>{{ bid.vendorName }}</span>
                  </td>
                  <td>
                    <span>{{ bid.fare ? bid.fare.total : "" }}</span>
                  </td>
                  <td>
                    <span>{{ bid.statusStr }}</span>
                  </td>
                  <td>
                    <z-confirm-button
                      class="float-right"
                      color="success"
                      small
                      fab
                      text
                      dark
                      :message="$i18n.t('Do you want to accept this bid ?')"
                      @click="acceptBid(bid)"
                    >
                      <v-icon>mdi-check</v-icon>
                    </z-confirm-button>
                  </td>
                </tr>
                <v-spacer></v-spacer>
              </tbody>
            </v-simple-table>
          </v-col>
        </v-row>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import { doGet } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component({
  name: "CargoRow",
  props: {
    value: {
      default: null,
    },
    refresh: {
      default: null,
    },
    _filterFor: {
      default: null,
    },
  },
})
export default class CargoRow extends Vue {
  cargo = null;

  get loading() {
    return common.loading;
  }

  async mounted() {
    if (this.value) {
      this.cargo = this.value;
    }
  }

  @Watch("value")
  onValueChange(val) {
    this.cargo = val;
  }

  deleteCargo() {
    this.$emit("deleteCargo", this.cargo);
  }

  formatDate(date) {
    if (date) {
      const dateStr = date.toString();
      return (
        dateStr.substring(6, 8) +
        "-" +
        dateStr.substring(4, 6) +
        "-" +
        dateStr.substring(0, 4)
      );
    } else {
      return "";
    }
  }
}
</script>
<style scoped>
/deep/ .v-btn--fab.v-size--small {
  height: 20px;
  width: 20px;
}
</style>
